import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';

import { ApplicationStateService } from 'src/app/services/application-state.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class InvoiceFooterComponent {
  @Input() showPayButton!: boolean | undefined;

  constructor(
    @Inject('INVOICE_TRACKING_KEY') private invoiceTrackingKey: string,
    private applicationState: ApplicationStateService,
    public router: Router
  ) {}

  handlePayClick(): void {
    this.applicationState.nextStep('payment');
    this.router.navigateByUrl(`/invoice/${this.invoiceTrackingKey}/payment`);
  }
}
